import styled from 'styled-components'

export const FixedColumn = styled.div`
  width: 200px;

  > div {
    width: 100%;
  }
`
